"use strict";

var _interopRequireWildcard = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
require("core-js/modules/es.function.name.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _router = _interopRequireWildcard(require("./router"));
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("./store"));
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
var _settings = require("@/settings");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _permission = require("./utils/permission");
// progress bar
// progress bar style
// get token from cookie

var language = _jsCookie.default.get("language") || "vi";
_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration
var whiteList = ['auth']; // no redirect whitelist
_router.default.beforeEach( /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(to, from, next) {
    var hasToken, accessRoute;
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // start progress bar
            _nprogress.default.start();
            // set page title
            // document.title = getPageTitle(messages[language][to.meta.title] ?? to.meta.title);
            document.title = (0, _getPageTitle.default)(to.meta.title);
            // determine whether the user has logged in
            hasToken = (0, _auth.getToken)();
            if (!hasToken) {
              _context.next = 44;
              break;
            }
            if (!(to.path === "/auth" && !to.query.resetCode)) {
              _context.next = 9;
              break;
            }
            // if is logged in, redirect to the home page
            next({
              path: "/"
            });
            _nprogress.default.done();
            _context.next = 42;
            break;
          case 9:
            if (!(whiteList.indexOf(to.path) !== -1)) {
              _context.next = 13;
              break;
            }
            next();
            _context.next = 42;
            break;
          case 13:
            _context.prev = 13;
            _context.next = 16;
            return _store.default.dispatch('user/getInfo');
          case 16:
            if (!(_settings.checkPermission && !_store.default.state.user.info.role)) {
              _context.next = 21;
              break;
            }
            _elementUi.Message.error('Bạn không có quyền truy cập');
            _store.default.commit('user/SET_TOKEN', '');
            (0, _auth.removeToken)();
            return _context.abrupt("return", next('/auth'));
          case 21:
            _context.next = 23;
            return _store.default.dispatch("permission/setRoutesAccess", _router.constantRoutes);
          case 23:
            if (!(_settings.checkPermission && to.meta.permission)) {
              _context.next = 33;
              break;
            }
            if (_store.default.state.permission.routes.length) {
              _context.next = 29;
              break;
            }
            _elementUi.Message.error('Bạn không có quyền truy cập');
            _store.default.commit('user/SET_TOKEN', '');
            (0, _auth.removeToken)();
            return _context.abrupt("return", next('/auth'));
          case 29:
            accessRoute = (0, _permission.checkAccessRoute)(to.path);
            if (accessRoute === true || !to.meta.permission) {
              next();
            } else {
              next(accessRoute);
            }
            _context.next = 34;
            break;
          case 33:
            next();
          case 34:
            _context.next = 42;
            break;
          case 36:
            _context.prev = 36;
            _context.t0 = _context["catch"](13);
            _elementUi.Message.error(_context.t0 || "Has Error");
            _store.default.dispatch('user/logout');
            next("/auth?redirect=".concat(to.path));
            _nprogress.default.done();
          case 42:
            _context.next = 45;
            break;
          case 44:
            /* has no token*/
            if (whiteList.indexOf(to.name) !== -1 || to.meta && !to.meta.permission) {
              // in the free login whitelist, go directly
              next();
            } else {
              // other pages that do not have permission to access are redirected to the login page.
              next("/auth?redirect=".concat(to.path));
              _nprogress.default.done();
            }
          case 45:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[13, 36]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});